
import React from "react";
import Header from "../shared/Header";
import Footer from "../shared/Footer";
import Contact from "../shared/Contact";
import { i18nManager } from "../../i18n";
import * as ReactRouterDom from "react-router-dom";
import { Debugger, CacheManager, Utils } from "../../utils";
import { FeatureFlagEvent, useFeatureFlags } from "@syllektis/oya-gbewa-react";
import { ApiResponseData, IPlatform, ISupportArticle, ISupportCategory, PlatformService, SanitizedResponse, SupportArticleService, SupportCategoryService } from "../../services";

function Landing() {
    const labels = i18nManager.Labels.landing;
    const navigate = ReactRouterDom.useNavigate();
    const { platform } = ReactRouterDom.useParams();
    const supportArticleService = SupportArticleService.getInstance();
    const supportCategoryService = SupportCategoryService.getInstance();
    const [supportArticles, setSupportArticles] = React.useState<ApiResponseData<ISupportArticle>>({});
    const [supportCategories, setSupportCategories] = React.useState<ApiResponseData<ISupportCategory>>({});
    const [activePlatform, setActivePlatform] = React.useState<IPlatform | undefined>(CacheManager.getPlatform(platform));
    const { enableSupportResources, allowUserTicketManagement } = useFeatureFlags({
        registerEvents: [FeatureFlagEvent.CHANGE],
        query: { platform },
        flags: {
            enableSupportResources: { id: "show-support-resources", initialValue: false },
            allowUserTicketManagement: { id: "allow-user-ticket-management", initialValue: false },
        },
    });

    React.useEffect(() => {
        if (!activePlatform) return;
        Utils.updateMeta({
            title: activePlatform.name,
            //logo: activePlatform.logo_url,
            desc: i18nManager.Labels.header.hero_title,
        });
        supportArticleService.querySupportArticles({ sort: "helpful,DESC", "platform.external_id": activePlatform?.external_id, size: 8 }).then(({ apiResponse }: SanitizedResponse<any>) => {
            Debugger.log("Landing:useEffect:querySupportArticles", apiResponse.data);
            setSupportArticles(apiResponse.data!);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
        supportCategoryService.querySupportCategories({ "platform.external_id": activePlatform?.external_id, size: 100 }).then(({ apiResponse }: SanitizedResponse<any>) => {
            Debugger.log("Landing:useEffect:querySupportCategories", apiResponse.data);
            setSupportCategories(apiResponse.data!);
        }).catch((error: SanitizedResponse<any>) => {
            Utils.reportError(error);
        });
    }, [activePlatform]);

    return (<div className="support">
        <Header reportPlatform={setActivePlatform} heroic />
        <div className="got-answers">
            <span className="q">{labels.got_questions}</span>
            <span className="a">{labels.we_got_answers}</span>
            <div className="top-articles">
                {supportArticles.content?.map((supportArticle) =>
                    (<ReactRouterDom.NavLink to={`/article/${supportArticle.title}`} key={supportArticle?.external_id}>{supportArticle.title}</ReactRouterDom.NavLink>))}
            </div>
        </div>
        <div className="faq-guide-support">
            {labels.fgs.filter((entry) => {
                if (entry.action_location.includes("resources")) return enableSupportResources;
                if (entry.action_location.includes("support/create")) return allowUserTicketManagement;
                return true;
            }).map((entry) => (<ReactRouterDom.NavLink to={"/" + platform + entry.action_location} key={entry.title}>
                {Utils.buildFaSvg(entry.icon)}
                <span className="title">{entry.title}</span>
                <span className="desc">{entry.desc}</span>
                <span className="lias">{entry.action_label} <i className="fa fa-arrow-right" /></span>
            </ReactRouterDom.NavLink>))}
        </div>
        <div className="categories">
            <span>{labels.browse_categories}</span>
            <div>
                {supportCategories.content?.map((supportCategory) =>
                (<ReactRouterDom.NavLink to={`/${platform}/category/${supportCategory.external_id}`} key={supportCategory?.external_id}>
                    <img alt={supportCategory.name} src={supportCategory.icon_location} />
                    <span className="title">{supportCategory.name}</span>
                    <span className="desc">{supportCategory.description}</span>
                </ReactRouterDom.NavLink>))}
            </div>
        </div>
        <Contact />
        <Footer />
    </div>);
}

export default Landing;
